import { OBSTETRIC_INDICATIONS, obstetricFindings } from "../groups/obstetric";
import { multi, OTHER, option, type UsWorksheetDefinition } from "../us-fields";

export const US_OB_TRANSVAGINAL: UsWorksheetDefinition = {
  examType: "us_ob_transvaginal",
  version: 1,
  indications: OBSTETRIC_INDICATIONS,
  otherIndication: true,
  sections: [
    {
      id: "obstetric_findings",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: obstetricFindings("Fetal Heart rate"),
    },
    {
      id: "obstetric_impression",
      label: "Impression",
      role: "impression",
      fields: [
        multi("obstetric.impression", "Impression", [
          option("live_iup", "Live intrauterine present"),
          option(
            "iup_without_heartbeat",
            "Intrauterine pregnancy without notable fetal heartbeat",
          ),
          option("no_definitive_iup", "No definitive intrauterine pregnancy"),
          option("ectopic_pregnancy", "Ectopic pregnancy"),
          option("indeterminate", "Indeterminate"),
          OTHER,
        ]),
      ],
    },
  ],
  normalImpressions: [{ sectionId: "obstetric_impression", value: "live_iup" }],
  billing: {
    codes: [
      {
        cpt: "76817",
        label: "Ultrasound, Pregnant Uterus, Transvaginal",
        preTick: true,
      },
    ],
  },
};
